module.exports = __webpack_public_path__ + "static/img/icon3.cb678ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/icon3.png
// module id = EKL4
// module chunks = 3